// extracted by css-extract-rspack-plugin
export default {"root":"Om3ycg","label":"tLHxZG"};